/**
 * BPP Backend API (Version: 1.0.0.0)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum BrokernetNotificationStatus {
    Gesendet = 'Gesendet',
    Gelesen = 'Gelesen'
  }

    export const BrokernetNotificationStatusTranslocoMap: Record<BrokernetNotificationStatus, string> = {
    [BrokernetNotificationStatus.Gesendet]: 'brokernetNotificationStatus.gesendet',
    [BrokernetNotificationStatus.Gelesen]: 'brokernetNotificationStatus.gelesen',
    };

    export const BrokernetNotificationStatusOptions = [
  { value: BrokernetNotificationStatus.Gesendet, labelKey: 'brokernetNotificationStatus.gesendet' },
  { value: BrokernetNotificationStatus.Gelesen, labelKey: 'brokernetNotificationStatus.gelesen' },
    ];

